export default {
	square: {
		w: 3,
		h: 3,
		p: [
			{ x: 0, y: 0 },
			{ x: 1, y: 0 },
			{ x: 1, y: 1 },
			{ x: 0, y: 1 },
			{ x: 0, y: 2 },
			{ x: 1, y: 2 },
			{ x: 2, y: 2 },
			{ x: 2, y: 1 },
			{ x: 2, y: 0 }
		]
	},

	lineH: {
		w: 3,
		h: 3,
		p: [
			{ x: 0, y: 1 },
			{ x: 1, y: 1 },
			{ x: 2, y: 1 }
		]
	},

	lineV: {
		w: 3,
		h: 3,
		p: [
			{ x: 1, y: 0 },
			{ x: 1, y: 1 },
			{ x: 1, y: 2 }
		]
	},

	x: {
		w: 3,
		h: 3,
		p: [
			{ x: 0, y: 0 },
			{ x: 1, y: 1 },
			{ x: 2, y: 2 },
			//-->Other diagonal
			{ x: 2, y: 0 },
			{ x: 0, y: 2 }
		]
	},

	arrowUp: {
		w: 3,
		h: 3,
		p: [
			{ x: 0, y: 2 },
			{ x: 1, y: 1 },
			{ x: 2, y: 2 }
		]
	},

	arrowRight: {
		w: 3,
		h: 3,
		p: [
			{ x: 1, y: 0 },
			{ x: 2, y: 1 },
			{ x: 2, y: 2 },
			{ x: 1, y: 2 }
		]
	},

	plus: {
		w: 3,
		h: 3,
		p: [
			{ x: 1, y: 0 },
			{ x: 1, y: 1 },
			{ x: 1, y: 2 },
			{ x: 0, y: 1 },
			{ x: 2, y: 1 }
		]
	}
};
